import { catalogLabel } from "../../utils/catalogLabel";
import { clearUser } from "../../analytics";
import { TRACK_IDS } from "../../analytics/trackIds";
import CinemaIcon from "../cinema/CinemaIcon";
import { getCinemaCopy } from "../../statics/cinemaCopy";
import React, { useContext, useEffect, useRef, useState } from "react";
import IconRender from "../../components/iconRender";
import { NavLink, useHistory, Link, useLocation } from "react-router-dom";
import { SessionContext } from "../../context/SessionContext";
import localizationStrings from "../../statics/localization";
import {
  defaultProfileAvatar,
  getColectAgent,
  getWs
} from "../../statics/config";
import { loadRequest } from "../../utils/loadRequest";
import useOutsideClick from "../../utils/useOutsideClick";
import SearchIcon from "../../assets/icons/svg/SearchIcon";
import LogoutConfirmation from "./LogoutConfirmation";
import { getMenuItems } from "../../api/category/categoryApi";
import mainLoadingGif from "../../assets/loading.gif";
import NotificationIcon from "../../assets/icons/svg/NotificationIcon";
import {
  callLogout,
  getUserInitialInfo,
  callTokenLogout
} from "../../api/user/user";
import { sendAliveReport } from "../../utils/reporting/customReporting";
import { reportingEvent } from "../../statics/reportEventId";
import moment from "moment";
import openKillSessionPopup from "../../utils/openKillSessionPopup";
import { normalizeApiText } from "../../utils/charset";
import { useCatalogTheme } from "../cinema/CatalogTheme";
import KidsBrand from "../cinema/KidsBrand";

const Navbar = () => {
  const { isKids } = useCatalogTheme();
  const copy = getCinemaCopy();
  const [posterUrl, setPosterUrl] = useState("");
  const [navbarElements, setNavbarElements] = useState([]);
  const [menuError, setMenuError] = useState(false);
  const menuPending = useRef(false);
  const menuMounted = useRef(false);
  const menuLoaded = useRef(false);
  //const [scrollState, setScrollState] = useState("top");
  const [showOptions, setShowOptions] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {
    userFrameConfig,
    hasLoggedIn,
    handleLogout,
    setSelectedMenuId,
    userInfo,
    profile
  } = useContext(SessionContext);

  const settingsRef = useRef(null);
  const profileTriggerRef = useRef(null);
  const history = useHistory(null);
  const location = useLocation();

  useOutsideClick(settingsRef, () => {
    setShowOptions(false);
  });

  let listener = null;
  let item = JSON.parse(localStorage.getItem("profile"));
  if (item?.pin) item.pin = window.atob(item.pin);
  let currentProfile = item;
  const allProfiles = JSON.parse(localStorage.getItem("profiles"));

  const clickNotConfirm = () => {
    setShowNotification(false);
  };

  const clickedLogout = () => {
    setShowOptions(false);
    setShowNotification(true);
  };

  const logout = async () => {
    let userCode = userInfo?.usercode;

    // If userInfo not available, check authentication type
    if (!userCode) {
      const sessionId = localStorage.getItem("sessionid");
      const interfaceUrl = localStorage.getItem("interfaceurl");
      const userToken = localStorage.getItem("userToken");
      const hasLoggedIn = localStorage.getItem("hasLoggedIn");

      if (!sessionId || !interfaceUrl) {
        // Using token-based authentication
        if (userToken && hasLoggedIn === "true") {
          let refreshToken = localStorage.getItem("refreshToken");

          if (!refreshToken) {
            // Check for refresh token in other localStorage keys
            for (let i = 0; i < localStorage.length; i++) {
              const key = localStorage.key(i);
              if (key.toLowerCase().includes("refresh")) {
                refreshToken = localStorage.getItem(key);
                break;
              }
            }
          }

          try {
            await callTokenLogout(refreshToken);
          } catch (error) {
            // Token logout failed, proceed with local logout
          }

          handleLogout();
          history.replace("/login");
          return;
        }

        // No valid authentication found
        handleLogout();
        history.replace("/login");
        return;
      }

      // Try to get userInfo for legacy session-based auth
      try {
        const { data: userInitData } = await getUserInitialInfo();
        if (userInitData?.returncode === "0") {
          userCode = userInitData.usercode;
        }
      } catch (error) {
        handleLogout();
        history.replace("/login");
        return;
      }
    }

    if (!userCode) {
      handleLogout();
      history.replace("/login");
      return;
    }

    // Legacy session-based logout
    try {
      const { data } = await callLogout(userCode);

      if (data.ReturnCode === "0") {
        let collectAgent = getColectAgent();
        if (collectAgent) {
          let eventtime = moment(
            moment().valueOf() - parseInt(localStorage.getItem("timeDiff"))
          )
            .utc()
            .format("yyyyMMDDHHmmss");

          collectAgent.logLogout({
            eventid: reportingEvent.E_LOGIN_OUT,
            eventtime: eventtime,
            actiontime: eventtime,
            result: "0",
            logintype: 0
          });
        }
        sendAliveReport();

        let ws = getWs();
        if (ws?.readyState === WebSocket.OPEN) {
          let prams = {
            TransactionID: JSON.stringify(new Date().getTime()),
            DeviceID: localStorage.getItem("deviceid"),
            UserID: userInfo?.usercode,
            TerminalFlag: 4,
            UserToken: userInfo?.usertoken,
            DKey: 0,
            Timestamp: JSON.stringify(new Date().getTime()),
            MsgType: "terminaldelreq"
          };
          ws.send(JSON.stringify(prams));
        }

        clearUser();
        if (parseInt(localStorage.getItem("logintype")) == 4) {
          const language = localStorage.getItem("language");
          localStorage.clear();
          if (language) {
            localStorage.setItem("language", language);
          }
          openKillSessionPopup(userFrameConfig?.easHttpsDomain);
        } else {
          const language = localStorage.getItem("language");
          localStorage.clear();
          if (language) {
            localStorage.setItem("language", language);
          }
          window.location.replace(userFrameConfig?.easHttpsDomain);
        }
      }
    } catch (error) {
      handleLogout();
      history.replace("/login");
    }
  };

  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath.includes("/dashboard/search")) {
      setSelectedMenuId("search");
    } else if (
      currentPath.includes("/dashboard/livetv") ||
      currentPath.includes("/dashboard/tvguide")
    ) {
      setSelectedMenuId("livetv");
    } else if (currentPath.includes("/dashboard/home")) {
      // Extract menuId from home routes like /dashboard/home/1/all
      const pathSegments = currentPath.split("/");
      const menuIndex = pathSegments.indexOf("home") + 1;
      if (menuIndex < pathSegments.length && pathSegments[menuIndex]) {
        setSelectedMenuId(pathSegments[menuIndex]);
      }
    }
  }, [location.pathname, setSelectedMenuId]);

  const renderedIcons = navbarElements?.map((el) => {
    return <IconRender key={el.id} text={catalogLabel(el.name)} link={el.id} align={true} />;
  });

  const renderedProfiles = allProfiles?.map((item) => {
    return item?.id != currentProfile?.id ? (
      <NavbarProfileItem key={item?.id} item={item} />
    ) : null;
  });

  const getNavbarItems = async () => {
    if (menuPending.current || menuLoaded.current) return;
    menuPending.current = true;
    setMenuError(false);
    try {
      const { data } = await loadRequest(getMenuItems);
      if (!menuMounted.current) return;
      if (!Array.isArray(data) || !data.length)
        throw new Error("Invalid menu response");
      setNavbarElements([
        ...data,
        { id: "livetv", name: localizationStrings.watchTv }
      ]);
      menuLoaded.current = true;
    } catch (error) {
      if (menuMounted.current) setMenuError(true);
    } finally {
      menuPending.current = false;
    }
  };

  useEffect(() => {
    menuMounted.current = true;
    window.addEventListener("online", getNavbarItems);
    return () => {
      menuMounted.current = false;
      window.removeEventListener("online", getNavbarItems);
    };
  }, []);

  useEffect(() => {
    getNavbarItems();
  }, [location.pathname]);

  useEffect(() => {
    if (currentProfile?.kid) {
      currentProfile.photo = "kids" + currentProfile?.photo;
    }
    let profilePoster = currentProfile?.avatar || defaultProfileAvatar;
    setPosterUrl(profilePoster);
  }, []);

  // useEffect(() => {
  //   listener = document.addEventListener("scroll", (e) => {
  //     var scrolled = document.scrollingElement.scrollTop;
  //     if (scrolled >= 10) {
  //       if (scrollState !== "amir") {
  //         setScrollState("amir");
  //       }
  //     } else {
  //       if (scrollState !== "top") {
  //         setScrollState("top");
  //       }
  //     }
  //   });
  //   return () => {
  //     document.removeEventListener("scroll", listener);
  //   };
  // }, [scrollState]);

  return (
    <>
      <nav
        className="navbar atlas-navbar"
        aria-label={localizationStrings.home}
      >
        <div className="navbar-row">
          <div className="menu-item-wrapper">
            <NavLink
              aria-label={isKids ? "Atlas Kids" : undefined}
              to={`/dashboard/home/${navbarElements[0]?.id || "home"}/all`}
              style={{ animation: "none" }}
            >
              <div data-track-id={TRACK_IDS.NAV_LOGO}
      className="main-logo">
                {/* //onClick={() => navigateHome()} */}
                {isKids ? (
                  <KidsBrand />
                ) : (
                  <img
                    alt="main logo"
                    src={require("../../assets/logo/atlas-logo.png")}
                    style={{ maxHeight: "3.13vw" }}
                  ></img>
                )}
              </div>
            </NavLink>
          </div>
          <div className="menu-item-wrapper atlas-nav-links">
            {renderedIcons}
            {menuError && (
              <button
                type="button"
                className="cinema-button cinema-button-secondary"
                aria-label={`${copy.retry}: ${localizationStrings.home}`}
                onClick={getNavbarItems}
              >
                {copy.retry}
              </button>
            )}
          </div>
          <div className="menu-item-wrapper">
            <div className="buttons-wrapper">
              <button
                type="button"
                aria-label={copy.search}
                data-track-id={TRACK_IDS.NAV_SEARCH}
                className={`search-field ${
                  location.pathname.includes("/dashboard/search")
                    ? "is-active"
                    : ""
                }`}
                onClick={() => {
                  history.push("/dashboard/search");
                }}
              >
                <CinemaIcon name="search" />
                <span>{copy.search}</span>
              </button>
              {/* <div className="notification-field">
                <NotificationIcon />
              </div> */}
            </div>
            {hasLoggedIn ? (
              <div className="settings-button">
                <div
                  className={`profile-logo-box ${hasLoggedIn ? "show" : ""}`}
                  ref={settingsRef}
                >
                  <button
                    type="button"
                    data-track-id={TRACK_IDS.NAV_PROFILE_MENU}
                    className="cinema-profile-trigger"
                    ref={profileTriggerRef}
                    aria-label={copy.profile}
                    aria-expanded={showOptions}
                    onClick={() => setShowOptions(!showOptions)}
                    onKeyDown={(event) => {
                      if (event.key === "Escape") setShowOptions(false);
                    }}
                  >
                    <div
                      className="profile-name"
                      title={normalizeApiText(currentProfile?.name)}
                    >
                      {normalizeApiText(currentProfile?.name)}
                    </div>

                    <div className="wrapper">
                      <img
                        alt="profile avatar"
                        className="profile-logo"
                        src={posterUrl}
                        onError={() => setPosterUrl(defaultProfileAvatar)}
                      ></img>
                    </div>
                    <CinemaIcon name="down" />
                  </button>
                  <div
                    onKeyDown={(event) => {
                      if (event.key === "Escape") {
                        setShowOptions(false);
                        const trigger =
                          settingsRef.current &&
                          settingsRef.current.querySelector("button");
                        if (trigger) trigger.focus();
                      }
                    }}
                    className={`settings-options-box ${
                      showOptions ? "show" : ""
                    }`}
                  >
                    {allProfiles?.length > 1 ? (
                      <div style={{ paddingBottom: "0.5vw" }}>
                        <NavbarProfileItem
                          item={currentProfile}
                          isActive={true}
                        />
                        <div className="seperator"></div>
                        {renderedProfiles}
                        <div
                          className="seperator"
                          style={{ marginTop: "0.68vw" }}
                        ></div>
                      </div>
                    ) : null}
                    <NavLink
                      to={{
                        pathname: `/profiles/all`
                      }}
                      style={{ textDecoration: "none" }}
                    >
                      <div data-track-id={TRACK_IDS.NAV_PROFILE_MANAGEMENT}
      className="profile-option">
                        {localizationStrings.profileManagement}
                      </div>
                    </NavLink>
                    <NavLink
                      to={{
                        pathname: `/dashboard/settings`
                      }}
                      style={{ textDecoration: "none" }}
                    >
                      <div
                        data-track-id={TRACK_IDS.NAV_SETTINGS}
                        className="profile-option"
                        onClick={() => setShowOptions(false)}
                      >
                        {localizationStrings.settings}
                      </div>
                    </NavLink>
                    {/* <div className="profile-option">Subscriptions</div> */}
                    <button
                      type="button"
                      data-track-id={TRACK_IDS.NAV_LOGOUT}
                      className="profile-option logout-button"
                      onClick={clickedLogout}
                    >
                      {localizationStrings.logout2}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className={`login-button-box ${hasLoggedIn ? "show" : ""}`}>
                <Link to="/login">
                  <div data-track-id={TRACK_IDS.NAV_LOGIN}
      className="button-login">
                    <span>{localizationStrings.signIn}</span>
                    <div className="seperator"></div>
                    <span>{localizationStrings.login.signUp}</span>
                  </div>
                </Link>
              </div>
            )}
          </div>
        </div>

        {showNotification ? (
          <LogoutConfirmation
            returnFocusRef={profileTriggerRef}
            onConfirm={() => {
              setIsLoading(true);
              setShowNotification(false);
              logout();
            }}
            onCancel={clickNotConfirm}
          />
        ) : null}
      </nav>{" "}
      {isLoading && (
        <div className="landing-container">
          <div className="main-loader-wrapper">
            <div className="main-loader">
              <img src={mainLoadingGif} />
            </div>
            <div className="loading-text">
              {localizationStrings.mainLoadingText}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const NavbarProfileItem = ({ item, isActive }) => {
  const [profileAvatar, setProfileAvatar] = useState(null);

  useEffect(() => {
    if (item) {
      if (item.kid) {
        item.photo = "kids" + item.posterName;
      }
      setProfileAvatar(item?.avatar || defaultProfileAvatar);
    }
  }, [item]);

  const ProfileItemContent = () => (
    <div className={`profile-option-item ${isActive ? "active" : ""}`}>
      <div className="profile-name">{normalizeApiText(item?.name)}</div>
      <div className="profile-img-wrapper">
        <img
          src={profileAvatar}
          alt="profile avatar"
          onError={() => setProfileAvatar(defaultProfileAvatar)}
        />
      </div>
    </div>
  );

  if (isActive) {
    return <ProfileItemContent />;
  }

  return (
    <NavLink
      to={{
        pathname: `/profiles/${item.id}`
      }}
      style={{ textDecoration: "none" }}
    >
      <ProfileItemContent />
    </NavLink>
  );
};

export default Navbar;
